import firebase, { fbAuth } from "./firebase";
const firebaseui = require("firebaseui");

const auth = firebase.auth();
export default auth;
export const ui = new firebaseui.auth.AuthUI(auth);
export const providers = [
  fbAuth.GoogleAuthProvider.PROVIDER_ID,
  fbAuth.GithubAuthProvider.PROVIDER_ID,
  fbAuth.EmailAuthProvider.PROVIDER_ID
];
